import React, { useEffect } from 'react';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import { ToastContainer } from 'react-toastify';
import $ from 'jquery';

import "react-toastify/dist/ReactToastify.css";

const Layout = ({ children }) => {

    useEffect(() => {
        $("#mobile-collapse").on("click", function(e) {
            e.preventDefault();
            if ($(".nxl-navigation").hasClass("mob-navigation-active")) {
                $(".nxl-navigation").removeClass("mob-navigation-active");
                $(".nxl-navigation .nxl-menu-overlay").remove();
            } else {
                $(".nxl-navigation").addClass("mob-navigation-active");
                $(".nxl-navigation").append('<div class="nxl-menu-overlay"></div>');
                $(".nxl-navigation .nxl-menu-overlay").on("click", function() {
                    $(".nxl-navigation").removeClass("mob-navigation-active");
                    $(".hamburger").removeClass("is-active");
                    $(this).remove();
                });
            }
        });

        $("#menu-mini-button").on("click", function() {
            $("#menu-mini-button").hide();
            $("#menu-expend-button").show();
            $("html").addClass("minimenu");
            localStorage.setItem("nexel-classic-dashboard-menu-mini-theme", "menu-mini-theme");
        });

        $("#menu-expend-button").on("click", function() {
            $("#menu-expend-button").hide();
            $("#menu-mini-button").show();
            $("html").removeClass("minimenu");
            localStorage.setItem("nexel-classic-dashboard-menu-mini-theme", "menu-expend-theme");
        });

        $(document).on("click", ".search-form-open-toggle", function(e) {
            e.preventDefault();
            $(".search-form").addClass("search-form-active").show(300);
        });

        $(document).on("click", ".search-form-close-toggle", function(e) {
            e.preventDefault();
            $(".search-form").removeClass("search-form-active").hide(300);
        });

        $(".app-sidebar-open-trigger").on("click", function(e) {
            e.preventDefault();
            $(".content-sidebar").addClass("app-sidebar-open");
        });

        $(".app-sidebar-close-trigger").on("click", function(e) {
            e.preventDefault();
            $(".content-sidebar").removeClass("app-sidebar-open");
        });

        $(document).on("click", ".page-header-right-open-toggle", function(e) {
            e.preventDefault();
            $(".page-header-right-items").addClass("page-header-right-open").removeClass("page-header-right-close");
        });

        $(document).on("click", ".page-header-right-close-toggle", function(e) {
            e.preventDefault();
            $(".page-header-right-items").addClass("page-header-right-close").removeClass("page-header-right-open");
        });

        $(document).on("click", ".page-content-left-open-toggle", function(e) {
            e.preventDefault();
            $(".page-content-left-sidebar-wrapper").addClass("page-content-left-open").removeClass("page-content-left-close");
        });

        $(document).on("click", ".page-content-left-close-toggle", function(e) {
            e.preventDefault();
            $(".page-content-left-sidebar-wrapper").addClass("page-content-left-close").removeClass("page-content-left-open");
        });

        $(document).on("click", ".page-content-right-open-toggle", function(e) {
            e.preventDefault();
            $(".page-content-right-sidebar-wrapper").addClass("page-content-right-open").removeClass("page-content-right-close");
        });

        $(document).on("click", ".page-content-right-close-toggle", function(e) {
            e.preventDefault();
            $(".page-content-right-sidebar-wrapper").addClass("page-content-right-close").removeClass("page-content-right-open");
        });

        return () => {
            $("#mobile-collapse").off("click");
            $(".nxl-navigation .nxl-menu-overlay").off("click").remove();
        };
    }, []);

    return (
        <div>
            <Header />
            <Menu />
            <div className="content">
                {children}
            </div>
            {/* <Footer /> */}
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
};

export default Layout;
